import { registerSW } from 'virtual:pwa-register';
import { Capacitor } from '@capacitor/core';

import { logger } from './logger';

let serviceWorkerRegistration: ServiceWorkerRegistration | undefined;

if (!Capacitor.isNativePlatform()) {
  registerSW({
    immediate: true,
    onOfflineReady() {
      logger.info('Service worker is ready for offline use');
    },
    onRegisteredSW(swScriptUrl, registration) {
      serviceWorkerRegistration = registration;
      logger.info('Service worker registered', {
        swScriptUrl,
        scope: registration?.scope ?? '(none)',
      });
    },
    onRegisterError(error) {
      logger.error('Service worker registration failed', error);
    },
  });
} else {
  logger.info('Skipping service worker registration on native platform');
}

export const requestServiceWorkerUpdate = async (): Promise<boolean> => {
  if (Capacitor.isNativePlatform()) {
    logger.debug('Service worker update request skipped on native platform');
    return false;
  }

  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) {
    logger.debug('Service worker update request skipped because service workers are unavailable');
    return false;
  }

  if (!serviceWorkerRegistration) {
    logger.warn('Service worker update requested before registration became available');
    return false;
  }

  try {
    logger.info('Requesting service worker update', {
      scope: serviceWorkerRegistration.scope,
    });
    await serviceWorkerRegistration.update();
    return true;
  } catch (error) {
    logger.error('Service worker update request failed', error);
    return false;
  }
};
